const getDistinctIds = (disabledChat, canRequestMeetingTo, chatEnabledFor) => {
  const parsedCanRequestMeetingTo = canRequestMeetingTo.map((id) => id.toString());
  if (disabledChat) return parsedCanRequestMeetingTo;
  const uniqueIds = new Set([...parsedCanRequestMeetingTo, ...chatEnabledFor]);
  return [...uniqueIds];
};
export default getDistinctIds;
